// The backend persists the reporting-friendly value as
// "Country (CC), State (CC-ST)" and separately stores the country code. DAT-501
// requires the UI field itself to show only the selected state/province. Older
// state-less-country rows may contain the same country twice, so choosing the
// final segment also normalizes those records.
export const normalizePlaceOfIssue = (value: string | undefined): string => {
  if (!value) return "";
  const parts = value
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);
  return parts[parts.length - 1] || "";
};
